// One-shot, in-memory hand-off from RecordScreen to RecordingDetail saying "this detail visit
// is the landing straight after capture, not someone opening the recording" (ONDEMAND-1).
// Under transcribe-on-demand, opening a deferred recording transcribes it — but landing on the
// detail screen because you just pressed Stop is not "opening" it, so RecordingDetail must not
// auto-ensure in that case (it offers a "Transcribe now" button instead).
//
// Same shape and reasoning as `pendingCaptions.ts`: module-level, NOT persisted (a reload is a
// genuine re-open, so losing the flag then is the correct behavior), and cleared on read so a
// later visit to the same recording counts as an open.

let justRecordedId: string | null = null;

/** Mark `recordingId` as just captured. Replaces any previous mark — only the most recent
 * session can still be landing on its detail screen. */
export function markJustRecorded(recordingId: string): void {
  justRecordedId = recordingId;
}

/** True (and clears the mark) iff the mark belongs to `recordingId`. */
export function takeJustRecorded(recordingId: string): boolean {
  if (justRecordedId !== recordingId) return false;
  justRecordedId = null;
  return true;
}
